import { render, staticRenderFns } from "./checklistCategory.vue?vue&type=template&id=5ca70d9f"
import script from "./checklistCategory.vue?vue&type=script&lang=js"
export * from "./checklistCategory.vue?vue&type=script&lang=js"
import style0 from "./checklistCategory.vue?vue&type=style&index=0&id=5ca70d9f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports